const shouldRenderPage = ({ sortBy, page }) => {
  return (!page && !sortBy) || parseInt(page) == 1 || sortBy == '1' || (!page && isNaN(sortBy));
};

export const PageValidator = ({ children, match }) => {
  return shouldRenderPage(match.params) ? children : null;
};
